!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('flights/searchRecent',['libs/ct_view', 'vendor/mustache', 'libs/ct_store', 'flights/flightPers', 'vendor/moment.min'], module)
	else
	//>>excludeEnd("requireTmpl"); 
		context[name] = module(CT.View, Mustache, CT.Store, CT.Pers)
}('searchRecent', function(View, Mustache, Store, Pers) {

	var recentSearchView = View({
		$el: $('.recentSearches'),

		initialize: function() {
			$(".recentSearches").find(".cancelRecent").bind('click', this.cancelRecentFn);
		},



		update: function(obj) {

		},

		
		
		hideRecent: function() {
			this.$el.hide();
		},
		
		

		cancelRecentFn: function(e) {
			var pers = new Pers();
			var refAnc = $(".recentSearches").find(".cancelRecent");
			pers.clear('recent');
			$('.tipsy').remove();
			this.$el.fadeOut();
		},
		
		/**
		 * Return minvalue for given Array.
		 *
		 */
		shcPrMinVal:function (_jsnArr, adult, child, ondate, flag){
			var _jsnPrArr = new Array();
			for (var i=0;i<_jsnArr.length;i++){
				if(ct.dates.diffDates(ondate, '15/04/2012') >= 0){
					_jsnPrArr.push(_jsnArr[i].pr * (parseInt(adult) + parseInt(child)));
				}else{
					if(flag == 'Y')//for intl
						_jsnPrArr.push(_jsnArr[i].pr * (parseInt(adult) + parseInt(child)));
					else{//for domestic
						if(_jsnArr[i].al != 'IT' || _jsnArr[i].al != 'IT-RED')
							_jsnPrArr.push(_jsnArr[i].pr * (parseInt(adult) + parseInt(child)));
					}
				}
			}
			var sort_arr = _jsnPrArr.sort();
				sort_arr = sort_arr.uniq();
			return sort_arr.min();
		},
	
		minPriceCal : function(priceJson, adult, child) {
			_.each(priceJson, function(o, idx) { 
				priceJson.pr =  Number(priceJson.pr) * (Number(adult) + Number(child));
			})
			
			return _.pick(_.min(priceJson, function(o) { return Number(o.pr) }), 'pr');
		},
		
		getCheapPrice: function(jsnArr, json) {
			var jsnArrOn, jsnArrRet, fareObj ={};
			var depart_date = json.dt;
			var return_date = json.rt;
			var adult = json.ad;
			var child = json.inf;
			var searchPrice = Number(json.spr);
			var searchDate = json.sd;
			var diffPrice=0;
			var status = -1;
			var minFare = 0;
			outJsonArr = jsnArr.onward ? jsnArr.onward : jsnArr
			jsnArrOn = outJsonArr[moment(depart_date, "DD/MM/YYYY").format("YYYYMMDD")];
			owPriceObj = jsnArrOn && jsnArrOn.length >0 && this.minPriceCal(jsnArrOn, adult, child);
			if(owPriceObj) minFare = Number(owPriceObj.pr);
			
			if(jsnArr.rturn) {
				jsnArrRet = jsnArr.rturn[moment(return_date, "DD/MM/YYYY").format("YYYYMMDD")];
				retPriceObj = jsnArrRet && jsnArrRet.length >0 && this.minPriceCal(jsnArrRet, adult, child);
				if(retPriceObj)  { minFare += Number(retPriceObj.pr); }
				else {minFare = 0;}
			}
			if(searchPrice && searchPrice < minFare){
				if(_.datesDuration(new Date(), new Date(searchDate) ) > 0) {
					diffPrice =  Math.abs(searchPrice - Number(minFare));
					status = 1; //Price up
				}
			}else if(searchPrice && searchPrice > minFare){
				if(_.datesDuration(new Date(), new Date(searchDate)) >0) {
					diffPrice =  Math.abs(Number(minFare) - searchPrice);
					status = 0;//Price Down
				}
			}
			
			fareObj['pr'] = minFare;
			fareObj['diffPr'] = parseInt(diffPrice);
			fareObj['searchDate'] = jsnArr['ctms'];
			fareObj['status'] = status;
			
	    	return fareObj;
		},
		
		render: function(_recentData) {
			var that = this;
			//language filter
			var recentData = _.filter(_recentData,function(rcd){
				if(CT.langUrlPrefix){
					return rcd.lng == CT.langUrlPrefix;
				}else{
					return !rcd.lng //if language is undefined (for old recent searches) OR empty (for new reecent searchs) for the english site
				}
				
			})
			if(recentData && recentData.length < 1){ return this.$el.hide(); }
			else
				{
				CT.utils.helperFunctions.trackGAUrl("/recentSearches_flight", 100);
				}
			
			//removing muticity data 
			recentData = _.filter(recentData, function(data) { return data.tt !== 'MultiCity'});
			filterRecentData = []; 
			var getUniqueData = function(fdata, rdata) {	
				var intChk =  (fdata.fr == rdata.fr &&  fdata.to == rdata.to &&  fdata.dt == rdata.dt);
				if(fdata.rt || rdata.rt) {
					return intChk && fdata.rt == rdata.rt;
				} else {
					return intChk; 
				}				
			}
			
			_.each(recentData, function(rdata, idx) {
				if(idx == 0) {
					filterRecentData.push(rdata);
				} else {
					if(_.filter(filterRecentData, function(fdata) { return getUniqueData(fdata, rdata) }).length === 0	) {
						filterRecentData.push(rdata);
					}				
				}
			});
			
			//recentData = recentData.slice(0,3);
			filterRecentData = filterRecentData.length === 1? filterRecentData : _(filterRecentData).first(CT.settings[CT.app].rcntSearchTrigger).value();
			that = this;
			// render recent search HTML
			this.filterRecentTab(filterRecentData, function(filterResult) {
				$liList = that.$el.find("li");
				_.each(filterResult, function(rs) {
					if(rs.status !== -1 && rs.diffPr >0) {
						rs.priceStatus = rs.status ? 'Up ' : 'Down ';
						rs.cls =  rs.status ? 'bad' : 'good ';
						rs.title = rs.status ? 'Up by ' : 'Dropped by ';
						rs.diffPr = CT.utils.formatForCurrency(Number(rs.diffPr), false, null, false)
					} else {
						rs.priceStatus = 0;
					}
					
					if(rs.pr > 0) {
						rs.pr = CT.utils.formatForCurrency(Number(rs.pr), false, null, false);
						$($liList[rs.idx]).find(".price").html(CT.to_html('PriceTmpl', rs));
					}
				});
			});
			
			if(CT.utils.helperFunctions.forceLanguagePrefix)
				CT.utils.helperFunctions.forceLanguagePrefix(that.$el);
			
			
			return this;
		},
		
		events : {
			"click #RecentSearch li" : 'recentSearchClick'
		},
		
		recentSearchClick :function(e){
			var recentSearchLabel =$.inArray(e.currentTarget, $(e.currentTarget).parent().children()) + 1;
			recentSearchLabel +=":"+$(e.currentTarget).find("a strong").text();
			recentSearchLabel +=":"+$(e.currentTarget).find("a").attr('href');
			CT.utils.helperFunctions.trackGAEvent('Flights_TS','Recent_Searches',recentSearchLabel,'100');
		},

		getCalendarJson : function(reqData , searchLen, isIntl,  orderIndx, json, callback, calResData, finalData){
			var rdata = reqData[0], that= this;
			var tripType = (json.rt) ? "RoundTrip" : "oneWay";
			var returnStr = '';
			if(tripType === "RoundTrip" && json.intl ==="y") {
				var deparTime = new Date(CT.utils.swapDayMonth(json.dt)).getTime();
				var returnTime = new Date(CT.utils.swapDayMonth(json.rt)).getTime();
				var tripLength = _.datesDuration(deparTime, returnTime); 
				returnStr = (tripLength.length>0) ? ("&return_after="+tripLength) :'';
			}

			
			$.ajax({
				type: "GET",
				url: CT.settings[CT.app].urls.calendarFare,
				data : rdata + returnStr,
				contentType: "application/json; charset=utf-8",
				dataType: "json",
		        success: function(response) {
					if(typeof response === "string") {
						try {
							response = JSON.parse(response)
						} catch(e) {
							response = response
						}
					}
					if(reqData.length >1){
						reqData.shift();
						calResData.onward = response.calendar_json;
		                that.getCalendarJson(reqData, searchLen, isIntl,  orderIndx, json, callback, calResData, finalData); //call the same function with second url
					}else{
						var currency = CT.settings.countryCurrCode[countryCode].code;
						if(isIntl ===  false && tripType == "RoundTrip"){ //Block for dom RT
		                	calResData.rturn = response.calendar_json;
		                	response.sell_currency_json.code = CT.settings.countryCurrCode[response.sell_currency_json.code.toLowerCase()].code
		                	window.disp_currency = response.sell_currency_json;
		             		window.sell_currency = window.sell_currency || {"code": currency, "symbol":""};
		                }else{
		                	calResData = response.calendar_json;//Block for dom OW,INTL OW & RT
		                	response.sell_currency_json.code = CT.settings.countryCurrCode[response.sell_currency_json.code.toLowerCase()].code
		                   	window.disp_currency = response.sell_currency_json;
		                	window.sell_currency = window.sell_currency || {"code": currency, "symbol":""};
			            }
		                
		            	CT.utils.resetCurrency();
		                
		                (function (resJson, json, orderIndx) {
		                	priceObj =  that.getCheapPrice(resJson, json);
	    					priceObj['idx'] = orderIndx;
	    					finalData.push(priceObj);
		    				
		    				if(finalData.length == searchLen){
		    					callback(finalData);
		    				} 
		                }) (calResData,  json, orderIndx);
		        	}
                }
			})
		},
		
		filterRecentTab: function(data, callback) {
			var origin, destination, reUri, adstr, cdstr,instr;
			var searchLen = data.length;
			var finalData=[]
			var that = this;
			var calResData = [];
			var html = [];
			
			
			_.each(data, function(json, idx) {
				var url;
				var returnSymb;
				var tripLength =0;
				var reqCalendarData = [];
				if(!json.dt) return false;
				origin = (json.ftg)?(json.ftg.split(",")[0]):(json.fr);
				destination = (json.ttg)?(json.ttg.split(",")[0]):(json.to);
				json.dpd = moment(json.dt, "DD/MM/YYYY").format("DD MMM");
				if(json.rt) {
					json.rd = moment(json.rt, "DD/MM/YYYY").format("DD MMM");
				}
				adstr = json.ad +" Adult"+ (json.ad >1 ? "s" :'');
				cdstr = json.cd > 0 ? (json.cd +" Child"+ (json.cd >1 ? "s" :'')) : '';
				instr = json.inf > 0 ? (json.inf +" Infant"+ (json.inf >1 ? "s" :'')) : '';
				json.paxInfo =  adstr + (cdstr ? ", " + cdstr  : "") + (instr ? ", " + instr  : "");
				json.arclass =  json.fl.cot;
				returnSymb = " \u21C4 "; 
				if($.browser.msie && parseInt($.browser.version, 10) < 9) {
					returnSymb = " &ndash; ";
				}
				json.sector = origin + (json.rt ? returnSymb  : " \u2192 ") + destination;
				
				url = []
				
				url.push("/flights/" + (json.intl == 'y'? 'international/' : '') + "results?")
				url.push("from="+json.fr)
				url.push("&to="+json.to)
				url.push("&depart_date="+json.dt)
				if(json.rt) url.push("&return_date="+json.rt)
				url.push("&adults="+json.ad)
				url.push("&childs="+json.cd)
				url.push("&infants="+json.inf)
				url.push("&class="+(json.fl.cot ? json.fl.cot : ''))
				url.push("&airline="+ (json.fl.al ? json.fl.al : ''))
				url.push("&carrier="+ (json.fl.carr ? json.fl.carr : ''))
				url.push("&intl="+ (json.intl || ''))
				json.searchUrl = url.join('')
				
				var recentSearch = {
					"recent": json
				};
				html.push(CT.to_html('RecentSearchTmpl', recentSearch));
				
				isIntl = (json.intl === "y")  ? true : false;
						
				//request data for onward
				owReqData = []
				owReqData.push("from="+json.fr)
				owReqData.push("&to="+json.to)
				owReqData.push("&start_date="+ moment(json.dt, "DD/MM/YYYY").format("YYYYMMDD"))
				owReqData.push("&end_date="+moment(json.dt, "DD/MM/YYYY").format("YYYYMMDD"))
				
				//request data for onward
				if(json.rt && isIntl) {
					tripLength = _.datesDuration(new Date(CT.utils.swapDayMonth(json.dt)), new Date(CT.utils.swapDayMonth(json.rt)) );
					owReqData.push("&return_after="+ Number(tripLength));
				}
				
				owReqData = owReqData.join('')
				reqCalendarData.push(owReqData);
				
				if(isIntl ===  false && json.rt) { //request data for return
					retReqData = []
					retReqData.push("from="+json.to)
					retReqData.push("&to="+json.fr)
					retReqData.push("&start_date="+ moment(json.dt, "DD/MM/YYYY").format("YYYYMMDD"))
					retReqData.push("&end_date="+moment(json.rt, "DD/MM/YYYY").format("YYYYMMDD"))
					retReqData = retReqData.join('')
					reqCalendarData.push(retReqData);
				}
				
				// make calendar ajax call
				$(window).load(function(){
					if(CT.settings[CT.app].showFareCalendar) {
						that.getCalendarJson(reqCalendarData, searchLen, isIntl, idx, json, callback, calResData, finalData)
					}
				})
			});
			
			if(html.length > 0) this.$el.css('display', 'block')
			$("#RecentSearch").html('').append(html.join('').trim());
			
		}
	})
	
	CT.subscribe('recent.update', function(lastSearchedObj){
		try{
			if(lastSearchedObj){
				var pers = new Pers()
				pers.set('recent', lastSearchedObj);
				lastSearchedObj.sd = new Date().getTime();
				Store("Recents").set('lastFormSearch'+(CT.langUrlPrefix||""), lastSearchedObj);
			}
		}catch(e){	
		}
	})

	var LRUStorage = {
		forDate : function(array,item,windowLength) {
			var currentSearch = CT.cache[CT.settings.currentTab].searchParams.clean;
			if(array.indexOf(item)<0 && item!=currentSearch.depart_date + (currentSearch.depart_date?('_' + currentSearch.depart_date):''))
				array.splice(0,0,item); // do not store if the current search matches the current date
			if (array.length>windowLength)
				array.length=windowLength
		},
		forSector : function(array,item,windowLength) {
			var currentSector = _.find(array,function(arrayItem){
				return arrayItem.name == item.name
			}) || item;
			this.forDate(currentSector.value,item.value[0],3)
			if(!_.find(array,function(arrayItem){return arrayItem.name == item.name}))
				array.splice(0,0,currentSector)
			if (array.length>windowLength)
				array.length=windowLength
		}
	}

	var reformatDate = function(dateString){
		return dateString.replace(/\//g,'-')
	}

	CT.subscribe('recent.update', function(lastSearch){ // for the recent and nearby search widget
		try{
			if(lastSearch.intl != 'y'){
				var storeData = [];
				if (Store("recentWidget").get('lastFormSearch'+lastSearch.trip_type)){
						storeData = Store("recentWidget").get('lastFormSearch'+lastSearch.trip_type)	
					}
				if(lastSearch){
					LRUStorage.forSector(storeData,{
						name : lastSearch.from+'-'+lastSearch.to,
						value : [reformatDate(lastSearch.depart_date)+(lastSearch.return_date?('_'+reformatDate(lastSearch.return_date)):'')]
					},10);
					Store("recentWidget").set('lastFormSearch'+lastSearch.trip_type, storeData);
			}
			}
		}catch(e){
		}
	})

	return recentSearchView;
}, CT.cache.views)
;
